import { Box, Flex, Text } from "@chakra-ui/react";
import colors from "theme/colors";
import { TableComposicaoContaData } from "core/features/conta/typings/index";
import { formatMoney } from "infra/helpers/number";
import TableItemRow from "./components/TableItemRow";
import moment from "moment";
interface TableComposicaoContaProps {
  data: TableComposicaoContaData | undefined;
  title?: string;
}
export default function TableComposicaoConta({
  data,
  title = "Composições",
}: TableComposicaoContaProps) {
  return (
    <Box mb={6}>
      <Flex
        bg={colors.black75}
        py={3}
        px={2}
        fontSize="14px"
        justifyContent="space-between"
        borderBottomColor={colors.black200}
        borderBottomWidth={1}
        borderTopRadius={15}
      >
        <Flex fontWeight="bold">{title}</Flex>
        <Flex fontWeight="bold">Valor</Flex>
      </Flex>

      {data?.composicoes?.length ? (
        <>
          {data.composicoes.map((composicoes, index) => (
            <TableItemRow
              key={index}
              bg={index % 2 === 0 ? "white" : colors.black75}
              breadcrumb={composicoes.categoriaFinanceira?.breadcrumb}
              id={composicoes.categoriaFinanceiraId}
              nome={composicoes.categoriaFinanceira?.nome}
              valor={composicoes.valor}
              complemento={composicoes.complemento}
            />
          ))}

          {Number.isFinite(data?.subtotal) ? (
            <Flex
              justifyContent="space-between"
              bg={data.composicoes.length % 2 === 0 ? "white" : colors.black75}
              py={3}
              px={2}
              pl={8}
              borderBottomColor={colors.black200}
              borderBottomWidth={1}
              fontWeight="bold"
            >
              Subtotal
              <Flex> {formatMoney(data?.subtotal ?? 0)}</Flex>
            </Flex>
          ) : null}
        </>
      ) : null}

      {data?.retencoes?.length ? (
        <>
          <Flex
            bg={data.composicoes.length % 2 === 0 ? colors.black75 : "white"}
            py={3}
            px={2}
            fontSize="14px"
            fontWeight="bold"
            justifyContent="space-between"
          >
            Retenções
          </Flex>

          {data.retencoes.map((retencao, index) => (
            <TableItemRow
              bg={
                (data.composicoes.length + index) % 2 === 0
                  ? "white"
                  : colors.black75
              }
              breadcrumb={retencao.categoriaFinanceira?.breadcrumb}
              id={retencao.categoriaFinanceiraId}
              nome={retencao.categoriaFinanceira?.nome}
              valor={retencao.valor}
              retencao
              color={"red"}
            />
          ))}

          <Flex
            justifyContent="space-between"
            bg={data?.composicoes.length! % 2 === 0 ? colors.black75 : "white"}
            py={3}
            px={2}
            pl={8}
            borderBottomColor={colors.black200}
            borderBottomWidth={1}
            fontWeight="bold"
          >
            Retenções
            <Flex color="red"> -{formatMoney(data?.totalRetencao)}</Flex>
          </Flex>
        </>
      ) : null}

      {data ? (
        <Flex
          justifyContent="space-between"
          bg={
            (data.composicoes.length + (data.retencoes?.length ?? 0)) % 2 === 0
              ? colors.black75
              : "white"
          }
          py={3}
          px={2}
          borderBottomColor={colors.black200}
          borderBottomRadius={15}
        >
          {!data?.dataPagamento && (data?.juros || data?.multa) ? (
            <>
              <Flex>
                Juros:
                <Text fontWeight="bold" mx="4px">
                  {formatMoney(data?.juros)}
                </Text>
                + Multa:
                <Text fontWeight="bold" mx="4px">
                  {formatMoney(data?.multa)}
                </Text>
                {data.valorTaxaCobranca ? (
                  <>
                    + Taxa de Cobrança:
                    <Text fontWeight="bold" mx="4px">
                      {formatMoney(data?.valorTaxaCobranca)}
                    </Text>
                  </>
                ) : null}
                {data.valorCorrecaoMonetaria ? (
                  <>
                    + Correção monetária:
                    <Text fontWeight="bold" mx="4px">
                      {formatMoney(data?.valorCorrecaoMonetaria)}
                    </Text>
                  </>
                ) : null}
                =
                <Text color="green" fontWeight="bold" mx="4px">
                  {formatMoney(
                    (data?.juros || 0) +
                      (data?.multa || 0) +
                      (data?.valorCorrecaoMonetaria || 0) +
                      (data?.valorTaxaCobranca || 0)
                  )}
                </Text>
              </Flex>
            </>
          ) : null}

          <Flex flex={1}>
            {data.desconto && !data.dataPagamento ? (
              <Flex mr="auto">
                Desconto: {formatMoney(data.desconto)}
                {data.descontoValidoAte ? (
                  <Text fontWeight="bold" mx="4px">
                    (válido até{" "}
                    {moment(data.descontoValidoAte).format("DD/MM/YYYY")})
                  </Text>
                ) : null}
              </Flex>
            ) : null}

            <Flex ml="auto">
              Valor Total :
              <Text fontWeight="bold" mx="4px">
                {formatMoney(
                  (data.total ?? 0) -
                    (!data.dataPagamento && data.desconto ? data.desconto : 0)
                )}
              </Text>
            </Flex>
          </Flex>
        </Flex>
      ) : null}
    </Box>
  );
}
